import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=8c7b20de&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=8c7b20de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7b20de",
  null
  
)

export default component.exports